import { combineReducers } from 'redux';
import persistReducer from "redux-persist/es/persistReducer";
import storage from 'redux-persist/lib/storage';
import ThemeReducer from './localthemereducer';


const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['auth']
}
const mainReducer = combineReducers({
    ThemeReducer: ThemeReducer,

})

export default persistReducer(persistConfig, mainReducer);

// code for scoop solutions